
















































import { Prop, Component, Vue } from "vue-property-decorator";
import { getProject, Project } from "@/api/project-api";
import assert from "assert";
import { assign } from "lodash";

interface StartProjectFormRequest {
  id?: number;
  // TODO: 施工者は1人じゃないのでどうするか相談
  //   operatorId: string; // 施工者ID
  startDate: string; // yyyy-MM-dd
  endDate: string; // yyyy-MM-dd
}

@Component({})
export default class StartProjectModal extends Vue {
  @Prop({ type: Number }) projectId?: number;

  project: Project | null = null;
  data: StartProjectFormRequest = {
    // TODO: 施工者は1人じゃないのでどうするか相談
    // operatorId: "",
    startDate: "",
    endDate: ""
  };
  error = "";

  hide() {
    (this.$refs["modal"] as any).hide();
  }

  reset() {
    this.project = null;
    this.error = "";
    this.$nextTick(async () => {
      assert(this.projectId);
      try {
        this.project = await getProject(this.projectId);
      } catch (e) {
        console.warn("network error", e);
      }
      if (this.project) {
        this.data = {
          startDate: this.project.start,
          endDate: this.project.end
        };
      } else {
        this.error = "現場を取得できませんでした。";
      }
    });
  }

  async startProject() {
    // TODO: 送信する
    console.warn(
      "startProject is not implemented yet",
      assign(this.data, {
        id: this.projectId
      })
    );
    this.hide();
  }
}
